import React from 'react';

const HowWeHelpSection: React.FC = () => {
  const features = [
    {
      title: "Curated Stock Picks:",
      description: "Top mining stocks that Robert is investing in, from gold to copper, with high-growth potential"
    },
    {
      title: "Real-Time Analysis:",
      description: "Drill Bits videos and instant commentary on company exploration announcements to keep you ahead of the herd"
    },
    {
      title: "10X Tracker:",
      description: "A dedicated channel to hunt mining stocks with 10x potential, analyzing past winners for patterns."
    },
    {
      title: "Deep-Dive Education:",
      description: "Courses like Jackpot! and Drilling for Dollars teach you how to evaluate mining shares to buy and avoid \"snake eyes\" projects."
    },
    {
      title: "Live Engagement:",
      description: "Real-time Q&As with Robert and industry experts for actionable insights."
    },
    {
      title: "Community Network:",
      description: "Connect with ambitious investors to share ideas and strategies."
    }
  ];

  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#F6F6F6] pt-20 pb-20">
      <div className="">
        {/* Header */}
        <div className="text-left mb-16 w-full lg:w-[80%]">
        <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7 lg:text-left">
            How We Help You Find the Best Mining Stocks
          </h2>
          <p className="text-[16px] md:text-[20px] lg:text-[26px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0">
          Join The Wealthy Miner's Mighty Networks community and gain access to tools designed to uncover the best mining companies to invest in:
          </p>
        </div>

        {/* Feature Blocks */}
        <div className="space-y-6">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-[10px] p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex lg:items-start  items-center space-x-4">
                {/* Icon */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 flex items-center justify-center border-r border-[#D9D9D9] pr-4">
                    <img 
                      src="/images/deep.webp" 
                      alt="Feature icon" 
                      className=""
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-[13px] md:text-[18px] lg:text-[20px] font-[700] text-[#000] mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-[11px] md:text-[16px] lg:text-[16px] text-[#000] leading-[1.6] font-[400]">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeHelpSection;
